import { FC } from "react"
import { Button } from "@unlimint/admin-ui-kit"

import { FormError } from "view/components/FormError"

import * as S from "./styled"

type TConfirmDeleteThemesProps = {
  error: string
  isSubmitting: boolean
  onCancel(): void
  onSubmit(): void
}

export const ConfirmDeleteThemes: FC<TConfirmDeleteThemesProps> = ({
  onSubmit,
  onCancel,
  error,
  isSubmitting,
}) => {
  return (
    <S.Wrapp>
      <S.Title>Do you want to delete this version?</S.Title>

      <S.ButtonsBlock>
        <Button size="small" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="small" onClick={onSubmit} disabled={isSubmitting}>
          Delete
        </Button>
      </S.ButtonsBlock>

      <FormError error={error} />
    </S.Wrapp>
  )
}
